import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-hulp-zorg',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconHulpZorg {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M28.99 9.03H8.95c-1.63 0-2.95 1.34-2.95 3l.03 9.99c0 .55.45 1 1 1H9v11.99c0 .55.45 1 1 1h6.96c.55 0 1-.45 1-1V13.02c0-.55.45-1 1-1s1 .45 1 1V35c0 .55.45 1 1 1h7.01c.55 0 1-.45 1-1V23h2a.984.984 0 0 0 1.01-.99v-9.98c0-1.66-1.35-3-3.01-3Zm-.35 4.98-.16.17-.76.8c-.39.41-1.06.41-1.45 0l-.76-.8-.16-.17c-.33-.35-.46-.88-.25-1.31.35-.71 1.2-.81 1.7-.29l.2.21.2-.21c.49-.51 1.34-.42 1.7.29.21.43.09.96-.25 1.31ZM21.48 3.54c0-1.93 1.57-3.5 3.51-3.5s3.51 1.57 3.51 3.5-1.57 3.5-3.51 3.5-3.51-1.57-3.51-3.5M9.46 3.5c0-1.93 1.57-3.5 3.51-3.5s3.51 1.57 3.51 3.5S14.91 7 12.97 7 9.46 5.43 9.46 3.5"/>
</svg>

    );
  }
}
